import { ClientConfig } from "../components/util/types/ClientConfig";

export const howdenConfig: ClientConfig = {
  agriCompanyCodesMap: [
    { name: "HDN_ITA", value: "035" },
    { name: "HDN_GBR", value: "023" },
  ],
  companyCodesMap: [
    { name: "HDN_ITA", value: "001" },
    { name: "HDN_GBR", value: "003" },
  ],
  domainName: "HowdenHorizon.com",
  defaultAddress: "Via Costanza Arconati, 1, 20135 Milano MI, Italy",
  defaultLocation: [9.21838, 45.45802],
  emergencyGeoJsonSubdirectory: "howden-terrasheld",
  geocoderSearchItalyOnly: false,
  greenPlaneCenter: [9.218795284249362, 45.45835443232962],
  label: "Howden",
  name: "howden",
  natCatPolicySelectionText: "Only policies  from HDNITA valid on 1/3/2025 are considered.",
  natCatEuroExplanationText: "Euro (shown with multiplication factor 330)",
  natCatGeoJsonSubDirectory: "natcat_hdn",
  redPlaneCenter: [-0.07829804617678227, 51.51435971416349],
  showHelpCenter: false,
  showNatCatAnalyticsFilter: false,
  tableColumns: {
    coinsuranceType: false,
    commercialProduct: false,
    sire: false,
  },
};
